import React from 'react'

const AddTemplate = () => {
  return (
    <div>AddTemplate</div>
  )
}

export default AddTemplate